module.exports = __webpack_public_path__ + "static/img/logo_2021_554d3ee.e5ceca6f.png";